/* @flow */
import { dispatcher } from 'lib/Dispatcher';
import { ErrorMessages } from 'constants/ErrorConstants';
import { ReduceStore } from 'flux/utils';

class ErrorStore extends ReduceStore {
  getInitialState() {
    return {
      title: null,
      body: null,
    };
  }

  getTitle() {
    return this.getState().title;
  }

  getBody() {
    return this.getState().body;
  }

  reduce(state, action) {
    const error = ErrorMessages[action.type];

    if (error) {
      const { title, body } = error[action.context || 'DEFAULT'];
      return Object.assign({}, state, { title, body });
    } else {
      return state;
    }
  }
}

export default new ErrorStore(dispatcher);



// WEBPACK FOOTER //
// ./src/stores/ErrorStore.js